/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-20 14:16:37
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Banner, TextStyle, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  onDismiss: Function,
  emailSupport: string
};

type ComposedProps = Props & WithI18nProps;

class DidYouKnow extends Component<ComposedProps> {
  state = {};

  render() {
    const { i18n, onDismiss, sendRequest } = this.props;

    return (
      <Banner
        title={i18n.translate('AdminHTML.Integration.DidYouKnow.title')}
        status="info"
        onDismiss={onDismiss}>
        <p>{i18n.translate('AdminHTML.Integration.DidYouKnow.content')}</p>

        <p className="send-request-text">
          <TextStyle variation="strong">
            {i18n.translate('AdminHTML.Common.Title.important')}
          </TextStyle>{' '}
          {i18n.translate('AdminHTML.Integration.DidYouKnow.contact')}{' '}
          <Link onClick={sendRequest}>
            {i18n.translate('AdminHTML.Common.Action.sendRequest')}
          </Link>
        </p>
      </Banner>
    );
  }
}

export default withI18n()(DidYouKnow);
